import React from "react"
import Image from "next/image"
import type { GeneralBynderAsset, ReducedImage } from "types/cms"

import { mobileImageContainer, desktopImageContainer } from "./Images.css"
import { isGeneralBynderAsset, isReducedImage } from "types/typeGuards"
import { cleanTitle } from "components/Contentful/RichTextRenderer/RichTextRenderer.utils"

type MobileProps = {
  title: string
  mobileImage: ReducedImage
  modulePosition: number
}

type DesktopProps = {
  title: string
  desktopImage: ReducedImage | GeneralBynderAsset
  modulePosition: number
}

const getImageDetails = (image, placeholder) => {
  const description = image?.description ?? "description"
  if (isGeneralBynderAsset(image)) {
    return {
      src: image.bynderData[0].thumbnails["OTF BETA"],
      description,
    }
  }
  if (isReducedImage(image)) {
    return {
      ...image,
      description,
    }
  }
  return {
    src: placeholder,
    description,
  }
}

export const MobileImage: React.FC<MobileProps> = ({
  title,
  modulePosition,
  mobileImage,
}) => {
  const image = getImageDetails(mobileImage, "/images/placeholders/800x800.svg")
  return (
    <div
      className={mobileImageContainer}
      data-testid={cleanTitle(`mob ${mobileImage.filename}`)}
    >
      <Image
        src={image.src}
        alt={image.description}
        title={title}
        priority={modulePosition < 3}
        width={800}
        height={800}
        sizes="100vw"
      />
    </div>
  )
}

export const DesktopImage: React.FC<DesktopProps> = ({
  title,
  modulePosition,
  desktopImage,
}) => {
  const image = getImageDetails(
    desktopImage,
    "/images/placeholders/1440x595.svg"
  )
  return (
    <div
      className={desktopImageContainer}
      data-testid={cleanTitle(`desk ${desktopImage.filename}`)}
    >
      <Image
        src={image.src}
        alt={image.description}
        title={title}
        priority={modulePosition < 3}
        unoptimized
        sizes="100vw"
        width={1600}
        height={900}
      />
    </div>
  )
}
